// src/pages/UnauthorizedPage.tsx
import React from 'react';
import './Unauthorized.css';
import { useSearchParams } from 'react-router-dom';
import { getAppContext } from '../utils/getAppContext';
import { getBrandConfig } from '../utils/brandConfig';

export default function UnauthorizedPage() {

  const [searchParams] = useSearchParams();
  const param1 = searchParams.get('message');
  const returnTo = searchParams.get('returnTo');

  const handleReroute = () => {
    // If a returnTo path was provided (e.g. /caddiegames/login for the
    // CaddieGames flow), go there directly — those failures happen before
    // any cookies are set so there's nothing to clear. Set forceReAuth so
    // LoginGate adds prompt=login to the next Auth0 request, which breaks
    // the SSO loop (Auth0 keeps a session even for denied users and would
    // silently re-deny without prompt=login).
    if (returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
      try { sessionStorage.setItem("asksmart.forceReAuth", "1"); } catch (_) {}
      window.location.href = returnTo;
      return;
    }
    // No returnTo — which is every RBAC denial, since ProtectedRoute sends
    // those here without one. Name the brand explicitly so the backend clears
    // the session and reopens THIS portal's door rather than AskSmart's.
    const brand = getBrandConfig(getAppContext()).brand;
    window.location.href =
      `${process.env.REACT_APP_BACKEND_URL}/clear-and-login` +
      `?brand=${encodeURIComponent(brand)}`;
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <div className="unauthorized-icon">❌</div>
        <h1>Access Denied</h1>
        <p>You are not authorized to enter at the moment.</p>
        <p>{param1}</p>
        <button
            type="button"
            className="registrationLoginBtn"
            onClick={handleReroute}
          >
            Back to Log In
          </button>
      </div>
    </div>
  );
}
